export function isSeated(state) {
  return ['SEATED', 'UNSEATED', 'CHECKED_OUT'].includes(state)
}
